import { login } from '../api/login'

export default {
	/**
	 * 登录
	 */
	startLogin({ commit }, param) {
		const form = Object.assign({}, param)
		return new Promise((resolve, reject) => {
			login(form)
				.then(res => {
					console.log(res)
					commit('setUserToken', res.token)
					commit('setUserId', res.admin.id)
					commit('setUserName', form.account)
					commit('setUserRoot', res.admin.is_root)
					resolve()
				})
				.catch(e => {
					reject(e)
				})
		})
	},
	/**
	 * 退出登录
	 */
	quitLogin({ commit }) {
		return new Promise(resolve => {
			commit('setUserToken', '')
			commit('setUserName', '')
			commit('setUserId', '')
			resolve()
		})
	}
}
